export default __webpack_public_path__ + "static/N0164-6a4811487e8b50803a09fdc2a800b5fe.png";